import React, { useEffect, useState } from 'react';
import { getTheme, toggleTheme } from '../../utils/theme';

/**
 * Small light/dark switch. Reflects and updates the global theme.
 */
export default function ThemeToggle({ className = '' }) {
    const [theme, setThemeState] = useState(getTheme());

    useEffect(() => {
        const onChange = (e) => setThemeState(e.detail);
        window.addEventListener('rw-theme-change', onChange);
        return () => window.removeEventListener('rw-theme-change', onChange);
    }, []);

    const isDark = theme === 'dark';

    return (
        <button
            type="button"
            onClick={() => setThemeState(toggleTheme())}
            aria-label={isDark ? 'Schakel naar lichte modus' : 'Schakel naar donkere modus'}
            title={isDark ? 'Lichte modus' : 'Donkere modus'}
            className={`btn btn-secondary btn-sm ${className}`}
            style={{ padding: '0.4rem 0.6rem' }}
        >
            {isDark ? (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="4" />
                    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
                </svg>
            ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M21 12.8A9 9 0 1111.2 3 7 7 0 0021 12.8z" />
                </svg>
            )}
        </button>
    );
}
